import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/33967fab-450d-4f89-a242-d08b1ca249e4";
export const REGISTER_URL = "https://a.ntrk2.com/ea577c12-5db6-408e-9993-8f0a349c4c92";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://wowbogota.kzw2a.com/download?openExternalBrowser=1&id=elr86jea0li1uek";

export * from "./codes";
export * from "./context";
